import { combineReducers } from 'redux';

import { BEZAHL_DE } from 'constants/PaymentConstants';
import * as actionTypes from 'modules/dealerConfiguration/administration/actionTypes';
import errorReducer from 'modules/global/reducers/generic.error';
import isLoadingReducer from 'modules/global/reducers/generic.loading';

import subscriptionStatusReducer from './status';

const integrations = [BEZAHL_DE];

/**
 * @typedef {{
 *   apiError: string,
 *   loading: boolean,
 *   status: import('./status').IntegrationStatus,
 * }} DealerConfigurationAdministrationIntegrationUIReducer
 */

export default combineReducers(
  integrations.reduce(
    (acc, integration) => ({
      ...acc,
      [integration]: combineReducers({
        apiError: errorReducer(actionTypes.SUBSCRIBE_INTEGRATION, {
          global: { matcher: ({ meta }) => meta.source === integration },
        }),
        loading: isLoadingReducer(actionTypes.SUBSCRIBE_INTEGRATION, {
          global: {
            matcher: ({ meta }) => meta.source === integration,
          },
        }),
        status: subscriptionStatusReducer(integration),
      }),
    }),
    {}
  )
);
